import NoDataFound from "components/common/NoDataFound";
import React, { useEffect, useState } from "react";
import { Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllWorkspaces,
  getEnableDisableSpaceStatus,
  updateEnableDisableSpaceStatus,
} from "store/actions/workspaceSlice";
import { showAlert } from "store/reducers/alertReducer";
import Spinners from "components/common/Spinners";
import Paginations from "components/common/Paginations";
import { getBranchListWithCity } from "store/actions/branchSlice";
import BranchDropdown from "pages/Dashboard/Overview/BranchDropdown";
import SpaceShimmer from "components/ShimmerEffects/SpaceShimmer";
import { InputSwitch } from "primereact/inputswitch";
import eye from "assets/images/icons/eye.svg";
import orderChange from "assets/images/icons/orderChange.svg";
import HotDeskCard from "./HotDeskCard";
import { getOrganistionList } from "store/actions/organizationSlice";
import { formatFilterOptions, getMinMaxDate } from "components/common/Utils";
import {
  resetWorkspaceFilterState,
  updateWorkspaceFilterState,
} from "store/reducers/workspaceReducer";
import Filters from "components/common/Filters";
import { orderByOptions, statusOptions } from "components/constants/StatusKeys";

const HotDesks = () => {
  const { t } = useTranslation();
  document.title = t("Hot Desks | Work Space");

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { search } = useLocation();
  const pageNumber = Number(new URLSearchParams(search).get("page")) || 1;

  const {
    isLoading,
    loading,
    workspaces,
    drafts,
    perPage,
    totalCount,
    totalPages,
    currentPage,
    spaceStatus,
    currentSpaceStatus,
    workspaceFilters,
  } = useSelector((state) => state.Workspace);
  const { organisationsList } = useSelector((state) => state.Organizations);

  const { keyword, selectedFilters, dates } = workspaceFilters;

  const { branchesWithCity } = useSelector((state) => state.Branches);

  const [selectedBranches, setSelectedBranches] = useState([]);

  const matchedSpace = currentSpaceStatus?.find(
    (space) => space.name === "hotDesk"
  );
  const [displayOrder, setDisplayOrder] = useState(null);

  useEffect(() => {
    if (matchedSpace) {
      setDisplayOrder(matchedSpace.displayOrder);
    }
  }, [matchedSpace]);

  useEffect(() => {
    getAllData();

    const fetchBranchesWithCity = () => {
      dispatch(getBranchListWithCity());
    };
    dispatch(getOrganistionList());

    fetchBranchesWithCity();
  }, []);

  const getAllData = (page, action) => {
    const { actionType } = action || {}; // SEARCH, RESET, RESET_KEYWORD
    const { orderBy, status, organizationId, branches } = selectedFilters;

    const isReset = actionType === "RESET";
    const payload = {
      spaceTypeInt: 5,
      perPage: perPage,
      pageNo: page || pageNumber,
      status: -1,
      orderBy: -1,
      keyword: isReset ? "" : keyword,
      dateRange: isReset ? {} : getMinMaxDate(dates),
      branches: isReset ? [] : branches,
      organizationId: isReset ? "" : organizationId,
    };
    dispatch(getAllWorkspaces(payload));
    dispatch(getEnableDisableSpaceStatus());
    navigate(`/bookings/hot-desks?page=${page || pageNumber}`);
  };

  const handleSelectionChange = (newSelected) => {
    setSelectedBranches(newSelected);
  };

  const handleBranchApply = () => {
    getAllData();
  };
  const searchfilters = [
    // {
    //   key: "status",
    //   placeholder: "Status",
    //   options: statusOptions,
    //   type: "singleSelect",
    // },
    // {
    //   key: "orderBy",
    //   placeholder: "Order By",
    //   options: orderByOptions,
    //   type: "singleSelect",
    // },
    {
      key: "organizationId",
      placeholder: "Organisation",
      options: formatFilterOptions(organisationsList),
      type: "singleSelect",
    },

    {
      key: "branches",
      type: "branchCityFilter",
    },
  ];

  const updateSpaceStatus = (id, isHide, newOrder) => {
    const payload = {
      id,
      displayOrder: newOrder,
      isHide,
    };
    dispatch(updateEnableDisableSpaceStatus(payload))
      .then((action) => {
        const { statusCode, success, message } = action?.payload;
        if (statusCode === 200 && success) {
          dispatch(
            showAlert({ text: "Status updated Successfully!", type: "success" })
          );
        } else {
          dispatch(showAlert({ text: message, type: "error" }));
        }
      })
      .catch((err) => {});
  };
  const setKeyword = (value) =>
    dispatch(updateWorkspaceFilterState({ keyword: value }));
  const setDates = (value) =>
    dispatch(updateWorkspaceFilterState({ dates: value }));
  const setSelectedFilters = (value) => {
    const updatedFilters =
      typeof value === "function" ? value(selectedFilters) : value;
    dispatch(updateWorkspaceFilterState({ selectedFilters: updatedFilters }));
  };
  const handleReset = () => {
    dispatch(resetWorkspaceFilterState());
    getAllData(1, { actionType: "RESET" });
  };

  return (
    <React.Fragment>
      <div className="page-content common_page">
        <Container fluid>
          <Row>
            <div className="g_between">
              <h1 className="main_title">{t("Hot Desks")}</h1>

              <div className="g_end gap-3">
                {/* <BranchDropdown
                  data={branchesWithCity}
                  label={t("Branch")}
                  allLabel={t("Choose All Branches")}
                  resetLabel={t("Reset all")}
                  onSelectionChange={handleSelectionChange}
                  selectedData={selectedBranches}
                  handleApply={handleBranchApply}
                /> */}
                <button
                  className="main_btn"
                  onClick={() => navigate("/bookings/hot-desks/add-new")}
                >
                  {t("Add New")}
                </button>
              </div>
            </div>
            <div className="common_filter_wrapper row my-4">
              <Filters
                keyword={keyword}
                setKeyword={setKeyword}
                onSearch={getAllData}
                selectedFilters={selectedFilters}
                setSelectedFilters={setSelectedFilters}
                dates={dates}
                setDates={setDates}
                filters={searchfilters}
                // setDates={(value) => dispatch(setDates(value))}
                onReset={handleReset}
              />
            </div>
            <div className="common_space_app_settings row">
              <div className="col-lg-6">
                <label htmlFor="">
                  <img
                    src={eye}
                    width={15}
                    height={15}
                    className="me-2"
                    alt=""
                  />
                  {t("Show in App")}
                </label>
                <div className="checkbox_div">
                  <InputSwitch
                    checked={!matchedSpace?.isHide ?? false} // use matchedSpace
                    onChange={() => {
                      if (!matchedSpace) return;

                      // Toggle isHide and send current displayOrder
                      updateSpaceStatus(
                        matchedSpace._id,
                        !matchedSpace.isHide,
                        matchedSpace.displayOrder
                      );
                    }}
                  />
                  <h2 className="fs_16 ms-2">
                    {t(
                      "Turn on to display the “Hot Desks” page in the app. Turn off to hide it"
                    )}
                  </h2>
                </div>
              </div>

              <div className="col-lg-6">
                <label htmlFor="">
                  <img
                    src={orderChange}
                    width={15}
                    height={15}
                    className="me-2"
                    alt=""
                  />
                  {t("Display Order in App")}
                </label>
                <div className="">
                  <select
                    value={displayOrder} // use state
                    onChange={(e) => {
                      const newOrder = Number(e.target.value);
                      setDisplayOrder(newOrder);
                      if (!matchedSpace) return;

                      updateSpaceStatus(
                        matchedSpace._id,
                        matchedSpace.isHide,
                        newOrder
                      );
                    }}
                  >
                    {[1, 2, 3, 4, 5].map((num) => (
                      <option key={num} value={num}>
                        {num}
                      </option>
                    ))}
                  </select>
                  <p className="short_desc">
                    {t(
                      "Choose the position of this page in the app menu. 1 shows first, higher numbers appear later"
                    )}
                  </p>
                </div>
              </div>
            </div>
          </Row>
          <div className="common_wrapper">
            <Row>
              {loading ? (
                <SpaceShimmer col={4} />
              ) : workspaces?.length === 0 ? (
                <NoDataFound text={t("No hot desks found")} />
              ) : (
                workspaces?.map((item) => (
                  <HotDeskCard
                    key={item?.id}
                    item={item}
                    isLoading={isLoading}
                  />
                ))
              )}
            </Row>
          </div>
          <h2 className="main_title">{t("Draft")}</h2>
          <div className="common_wrapper">
            {loading ? (
              <SpaceShimmer col={4} />
            ) : drafts?.length === 0 ? (
              <NoDataFound text={t("No drafts saved yet")} />
            ) : (
              <Row>
                {drafts?.map((item) => (
                  <HotDeskCard
                    key={item?.id}
                    item={item}
                    className="draft"
                    isLoading={isLoading}
                  />
                ))}
              </Row>
            )}
          </div>
          {!loading && (
            <Paginations
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={(page) => {
                getAllData(page);
              }}
              totalCount={totalCount}
            />
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default HotDesks;
